import { Avatar, Card, Flex, Group, Text, Stack } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import useGetConvites from "@/components/app-container/useGetConvites";
import Can from "@/components/can";
import EditItemButton from "@/components/edit-item-button";
import colaboradorSchema from "@/modules/colaboradores/schema/colaborador-schema";
import useUserStore from "@/modules/users/store";
import { extractInitialsFromText } from "@/utils/text";
// prettier-ignore
const CardColaborador = () => {
  const colaborador = useUserStore((state) => state.colaborador);
  const { data } = useGetConvites();

  if (!colaborador) {
    return null;
  }

  const name = colaborador.nome || colaborador.email;
  return (
    <Card style={{ flex: 1 }} withBorder p="lg" pos="relative" h={186}>
      <Flex align="center" h="100%">
        <Group gap="xl">
          <Avatar src={null} alt={name} size="xl">
            {extractInitialsFromText(name)}
          </Avatar>
          <Stack>
            <div>
              <Text fw={500}>{colaborador.nome}</Text>
              <Text c="dimmed" tt="lowercase">
                {colaborador.role}
              </Text>
            </div>
            <div>
              <Text fw={500}>{colaborador.email}</Text>
              <Text c="dimmed">Email</Text>
            </div>
          </Stack>
        </Group>
      </Flex>
      {data && data.length === 0 || colaborador?.role === "ADMIN" ? <Can I="update" this={colaborador}>
        <EditItemButton
          modal="colaborador-form-modal"
          schema={colaboradorSchema}
          item={colaborador}
          size="xs"
          pos="absolute"
          top={20}
          right={30}
        >
          <Group gap={4}>
            <IconEdit size="1.2rem" stroke={1.5} />
            Editar
          </Group>
        </EditItemButton>
      </Can> : <></>}
    </Card>
  );
};

export default CardColaborador;
